const deleteTenants = {
  toastr: 'Tenant deletada',
  toastr1: ' deletada com sucesso'
};

export default deleteTenants;
